export default "/images/feeding_practices_sm.jpg?d2a760ad8e70ba1bde1532e478feef22";